// const BASE_API_URL = "http://localhost:3200";
// const BASE_API_URL = "https://nodeapp.barodaweb.com";
const BASE_API_URL = "https://api.marfatia.net";

export { BASE_API_URL };
